<div
  class="mainselect"
  (click)="toggleOptions($event.target)"
  (blur)="onTouched()"
  tabindex="0"
>
  <span class="selecttext">
    <img
      [src]="selectedIcon"
      *ngIf="selectedIcon !== '' && iconType == 'image'"
      alt=""
    />
    {{ selectedName }}
  </span>
  <rr-icon name="chevron-down"></rr-icon>
</div>

<!-- Dropdown -->
<div
  class="backdrop"
  (click)="toggleOptions($event.target)"
  *ngIf="showOptions"
></div>
<div
  class="selectoptions"
  *ngIf="showOptions"
  [style.width]="elementWidth"
  [style.marginTop]="elementHeight"
>
  <div
    class="selectoption"
    *ngFor="let option of options"
    (click)="selectOption(option)"
  >
    <rr-icon
      *ngIf="option?.icon && iconType == 'icon'"
      [name]="option.icon"
    ></rr-icon>
    <img
      [src]="option.icon"
      *ngIf="option?.icon && iconType == 'image'"
      alt=""
    />
    {{ option[optionName] }}
  </div>
</div>
